import omit from 'lodash-es/omit'

export function getConfirmationProps(props) {
  return omit(props, ['Component', 'onCancel', 'onSubmit'])
}
